var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowRightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.329505 0.454505C0.768845 0.015165 1.48116 0.015165 1.9205 0.454505L8.6705 7.2045C9.10983 7.64384 9.10983 8.35616 8.6705 8.7955L1.9205 15.5455C1.48116 15.9848 0.768845 15.9848 0.329505 15.5455C-0.109835 15.1062 -0.109835 14.3938 0.329505 13.9545L6.28401 8L0.329505 2.0455C-0.109835 1.60616 -0.109835 0.893845 0.329505 0.454505Z",
    fill: "#284FAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRightBlue);
export default __webpack_public_path__ + "static/media/ic-arrow-right-blue.68776146254731409194a8bd15d766af.svg";
export { ForwardRef as ReactComponent };